// extracted by mini-css-extract-plugin
export default {"loading":"MediaDetailsLoading_loading__wc08H"};